module.exports = __webpack_public_path__ + "media/images/element/15-5fc9d86272f364b136e65c2f1ea102eb.svg";